module.exports = __webpack_public_path__ + "img/oxt.9788877c.svg";